import React, { Component } from 'react';
import { TCallStatus } from './types/index';
import { SUCCESS, LOADING } from '../../../models/request-status';

type Props = {
  testConnection: () => void;
  testingCredentials: TCallStatus;
  savingChanges: TCallStatus;
  saveChanges: () => void;
};

class TestConnection extends Component<Props> {
  render() {
    const { testConnection, testingCredentials, savingChanges, saveChanges } = this.props;
    return (
      <React.Fragment>
        <div className="test-connection">
          <button className="test-connection-button" onClick={testConnection}>
            {testingCredentials === LOADING ? (
              <span className="spinner reset" />
            ) : (
              'Test connection'
            )}
          </button>
        </div>
        <button
          disabled={testingCredentials !== SUCCESS}
          className="save-button"
          onClick={saveChanges}
        >
          {savingChanges === LOADING ? <span className=" spinner reset" /> : 'Save Changes'}
        </button>
      </React.Fragment>
    );
  }
}

export default TestConnection;
